import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { EXPERIMENT_SETTINGS_PROCESSING_SAVE, EXPERIMENT_SETTINGS_PROCESSING_ERROR } from 'redux/actionTypes/experimentSettings';
import errorTypes from 'redux/actions/experimentSettings/errorTypes';
import endUserMessages from 'utils/endUserMessages';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
var saveProcessingSettings = function saveProcessingSettings(experimentId, settingName) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var content, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            content = getState().experimentSettings.processing[settingName];
            _context.prev = 1;
            _context.next = 4;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/processingConfig"), {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify([{
                name: settingName,
                body: content
              }])
            });
          case 4:
            dispatch({
              type: EXPERIMENT_SETTINGS_PROCESSING_SAVE,
              payload: {
                experimentId: experimentId,
                settingName: settingName
              }
            });
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_SAVING);
            dispatch({
              type: EXPERIMENT_SETTINGS_PROCESSING_ERROR,
              payload: {
                error: errorMessage,
                errorType: errorTypes.SAVE_PROCESSING_SETTINGS
              }
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default saveProcessingSettings;